import React from "react";

const Logo = () => (
    <svg width="153" height="18" viewBox="0 0 153 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M119 9C119 11.7614 116.761 14 114 14C111.239 14 109 11.7614 109 9C109 6.23858 111.239 4 114 4C116.761 4 119 6.23858 119 9Z"
            fill="#9FE015"
        />
        <path
            d="M136 9C136 11.7614 133.761 14 131 14C128.239 14 126 11.7614 126 9C126 6.23858 128.239 4 131 4C133.761 4 136 6.23858 136 9Z"
            fill="#C9F668"
        />
        <path
            d="M153 9C153 11.7614 150.761 14 148 14C145.239 14 143 11.7614 143 9C143 6.23858 145.239 4 148 4C150.761 4 153 6.23858 153 9Z"
            fill="#E8FEB9"
        />
        <path d="M0.259766 0.799973H6.41977V2.47997H2.51977V17H0.259766V0.799973Z" fill="#333333" />
        <path
            d="M10.6999 15.32C11.2733 15.3333 11.7199 15.2266 12.0399 15C12.3599 14.7733 12.6266 14.24 12.8399 13.4C13.0533 12.56 13.2199 11.2333 13.3399 9.41997L13.8799 0.799973H20.9999V17H18.7399V2.47997H15.8199L15.4399 9.41997C15.3333 11.2333 15.1533 12.6733 14.8999 13.74C14.6466 14.8066 14.2333 15.62 13.6599 16.18C13.0866 16.74 12.2733 17.02 11.2199 17.02C10.9933 17.02 10.8199 17.0133 10.6999 17V15.32Z"
            fill="#333333"
        />
        <path
            d="M31.101 0.799973H33.261L36.741 17H34.581L33.841 12.92H30.541L29.781 17H27.641L31.101 0.799973ZM33.541 11.3L32.201 3.99997L30.841 11.3H33.541Z"
            fill="#333333"
        />
        <path
            d="M43.3652 0.799973H47.0852C48.5519 0.799973 49.6386 1.13331 50.3452 1.79997C51.0519 2.45331 51.4052 3.47331 51.4052 4.85997C51.4052 6.92664 50.6319 8.06664 49.0852 8.27997C50.0452 8.50664 50.7452 8.95997 51.1852 9.63997C51.6252 10.3066 51.8452 11.22 51.8452 12.38C51.8452 13.8333 51.4986 14.9666 50.8052 15.78C50.1252 16.5933 49.0852 17 47.6852 17H43.3652V0.799973ZM46.9652 7.55997C47.8986 7.55997 48.5452 7.35997 48.9052 6.95997C49.2652 6.54664 49.4452 5.84664 49.4452 4.85997C49.4452 4.13997 49.3319 3.61331 49.1052 3.27997C48.8919 2.93331 48.5652 2.71331 48.1252 2.61997C47.6852 2.52664 47.0319 2.47997 46.1652 2.47997H45.6252V7.55997H46.9652ZM47.1452 15.38C47.8119 15.38 48.3252 15.28 48.6852 15.08C49.0586 14.8666 49.3186 14.5466 49.4652 14.12C49.6119 13.6933 49.6852 13.1133 49.6852 12.38C49.6852 11.34 49.4719 10.5666 49.0452 10.06C48.6186 9.53997 47.9252 9.27997 46.9652 9.27997H45.6252V15.38H47.1452Z"
            fill="#333333"
        />
        <path
            d="M58.8535 0.799973H61.1135V7.79997H65.2735V0.799973H67.5335V17H65.2735V9.41997H61.1135V17H58.8535V0.799973Z"
            fill="#333333"
        />
        <path
            d="M79.2045 17.18C77.6178 17.18 76.4778 16.7333 75.7845 15.84C75.1045 14.9333 74.7645 13.6266 74.7645 11.92V5.77997C74.7645 4.09997 75.1111 2.82664 75.8045 1.95997C76.4978 1.09331 77.6311 0.659973 79.2045 0.659973C80.7778 0.659973 81.9111 1.09997 82.6045 1.97997C83.2978 2.84664 83.6445 4.11331 83.6445 5.77997V11.94C83.6445 13.62 83.2978 14.9133 82.6045 15.82C81.9111 16.7266 80.7778 17.18 79.2045 17.18ZM79.2045 15.4C80.0578 15.4 80.6311 15.1533 80.9245 14.66C81.2178 14.1666 81.3644 13.42 81.3644 12.42V5.31997C81.3644 4.33331 81.2178 3.60664 80.9245 3.13997C80.6311 2.65997 80.0578 2.41997 79.2045 2.41997C78.3511 2.41997 77.7778 2.65997 77.4845 3.13997C77.1911 3.60664 77.0444 4.33331 77.0444 5.31997V12.42C77.0444 13.42 77.1911 14.1666 77.4845 14.66C77.7778 15.1533 78.3511 15.4 79.2045 15.4Z"
            fill="#333333"
        />
        <path
            d="M90.8652 0.799973H97.1452V2.47997H93.1252V7.83997H96.3852V9.43997H93.1252V15.38H97.1852V17H90.8652V0.799973Z"
            fill="#333333"
        />
    </svg>
);

export default Logo;
